/* eslint-disable complexity */
import { GetScheduleDataAddProps } from "../../../../models/add"
import {
  ScheduleDataAddType,
  ScheduleInfoAddType,
} from "../../../../models/add/DataAdd"
import { getScheduleDataTableAdd } from "../getDataTableAdd"
import { getScheduleInfoAdd } from "./getInfoAdd"

export const getScheduleDataAdd = async (
  props: GetScheduleDataAddProps,
): Promise<ScheduleDataAddType> => {
  const {
    allCountries,
    dataSubmit,
    departments,
    detailDataSource,
    detailIndexIdentity,
    id,
    isFromSCR114UserSearch,
    isHiredLocally,
    isOtherStaffNumber,
    isSchedulesAdd,
    isSchedulesEdit,
    lodgingIndexIdentity,
    purposeTravelList,
    schedulesData,
    stayIndexIdentity,
    transportationList,
    travelerBase,
    travelerDetail,
    travelerId,
  } = props

  const scheduleInfoSubmit: ScheduleInfoAddType = isSchedulesEdit
    ? {
        travelScheduleId: id,
        ...getScheduleInfoAdd({
          dataSubmit,
          departments,
          isOtherStaffNumber,
          purposeTravelList,
          travelerId,
        }),
      }
    : getScheduleInfoAdd({
        dataSubmit,
        departments,
        isOtherStaffNumber,
        purposeTravelList,
        travelerBase,
        travelerDetail,
        travelerId,
      })

  const {
    schedulesAddDetailsSubmit,
    schedulesAddLodgingsSubmit,
    schedulesAddStaysSubmit,
  } = await getScheduleDataTableAdd({
    allCountries,
    dataSubmit,
    detailDataSource,
    detailIndexIdentity,
    id,
    isHiredLocally,
    isSchedulesAdd,
    isSchedulesEdit,
    lodgingIndexIdentity,
    schedulesData,
    stayIndexIdentity,
    transportationList,
  })

  return {
    details: schedulesAddDetailsSubmit,
    info: scheduleInfoSubmit,
    isFromSCR114UserSearch: isFromSCR114UserSearch,
    lodgings: schedulesAddLodgingsSubmit,
    stays: schedulesAddStaysSubmit,
  }
}
